var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemandForecasting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_16556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5915 14.4207C25.6909 14.2324 25.5543 14.0065 25.3418 14.0065H18.5939H16.0786C15.9129 14.0065 15.7825 13.8643 15.7973 13.6992L16.9276 0.983934C16.955 0.67659 16.5405 0.554355 16.3965 0.827276L7.0487 18.5429C6.9493 18.7312 7.08594 18.957 7.29844 18.957H14.0463H16.5616C16.7274 18.957 16.8577 19.0993 16.843 19.2644L15.7126 31.9796C15.6852 32.287 16.0997 32.4092 16.2437 32.1363L25.5915 14.4207Z",
    fill: "#F1935C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_16556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemandForecasting);
export default __webpack_public_path__ + "static/media/demandForecasting.9dd7578d9a370aead5a7f76e1f060594.svg";
export { ForwardRef as ReactComponent };